import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {
    SEARCH_AUDIT_TRAIL,
    SEARCH_AUDIT_TRAIL_SUCCESS,
    SEARCH_AUDIT_TRAIL_FAILED,
    VIEW_AUDIT_TRAIL,
    VIEW_AUDIT_TRAIL_SUCCESS,
    VIEW_AUDIT_TRAIL_FAILED,
    BACK_TO_LOGIN,
    GET_LIST_MODULE_NAME,
    GET_LIST_MODULE_NAME_SUCCESS,
    GET_LIST_MODULE_NAME_FAILED
} from "constants/ActionTypes";
import {
    searchAuditTrailApi,
    viewAuditTrailApi,
    listModuleNameApi
} from "../../appRedux/api/AuditTrail";
import { mapAuditTrailMenuCatalog } from "../../appRedux/api/authHelpers";
import { apiHandler, IDP_INQUIRY_SUCCESS } from "./handler";


function* fetchSearchAuditTrail({payload}) {
    if(payload != null){
        try {
            const searchAuditTrailData = yield call(searchAuditTrailApi, payload);
            if (searchAuditTrailData.data.abstractResponse.responseStatus === 'INQ000') {
                yield put({type: SEARCH_AUDIT_TRAIL_SUCCESS, payload: searchAuditTrailData.data});
            } else{          
                yield put({type: SEARCH_AUDIT_TRAIL_FAILED, payload: searchAuditTrailData.data.abstractResponse.responseMessage});
            }
        } catch (error) {
            if(error.response !== undefined) {
                if (error.response.data.abstractResponse.responseStatus === 'AUTH001') {
                    yield put({type: BACK_TO_LOGIN, payload: error.response.data.abstractResponse.responseMessage});
                } else {
                    yield put({
                        type: SEARCH_AUDIT_TRAIL_FAILED,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                }
            }
        }
    }
}

function* fetchAuditTrail({ payload }) {
    if (payload != null) {
        const { ok, data, message } = yield* apiHandler(viewAuditTrailApi, payload, {
            successCodes: ['MEM000', ...IDP_INQUIRY_SUCCESS],
        });

        if (ok) {
            yield put({
                type: VIEW_AUDIT_TRAIL_SUCCESS,
                payload: data.body != null ? data.body : data.member,
            });
        } else {
            yield put({ type: VIEW_AUDIT_TRAIL_FAILED, payload: message });
        }
    }
}

function* fetchListModuleName({payload}) {
    if(payload != null){
        const { ok, data, message } = yield* apiHandler(listModuleNameApi, payload);

        if (ok) {
            yield put({type: GET_LIST_MODULE_NAME_SUCCESS, payload: mapAuditTrailMenuCatalog(data.body)});
        } else {
            yield put({type: GET_LIST_MODULE_NAME_FAILED, payload: message});
        }
    }
}


export function* searchAuditTrail() {
    yield takeEvery(SEARCH_AUDIT_TRAIL, fetchSearchAuditTrail);
}

export function* viewAuditTrail(){
    yield takeEvery(VIEW_AUDIT_TRAIL, fetchAuditTrail);
}

export function* getListModuleName() {
    yield takeEvery(GET_LIST_MODULE_NAME, fetchListModuleName);
}


// yield all
export default function* rootSaga() {
    yield all([
        fork(searchAuditTrail),
        fork(viewAuditTrail),
        fork(getListModuleName)
    ]);
}
